import type { Product } from '../../types/product';
import type { Contact } from '../../types/contact';
import type { Stock } from '../../types/stock';
import type { ActivityType } from '../../types/activityType';

/**
 * Спільний об'єкт фільтрів для активностей
 * Використовується для передачі між сторінками та збереження всіх фільтрів в одному місці
 */
export interface ActivityFilters {
  products: Product[];
  clients: Contact[];
  stocks: Stock[];
  providers: Contact[];
  activityTypes: ActivityType[];
  serialNumber?: string;
  fromDate?: string;
  toDate?: string;
  showOnlyActive?: boolean;
}

/**
 * Створює порожній об'єкт фільтрів
 */
export const createEmptyFilters = (): ActivityFilters => ({
  products: [],
  clients: [],
  stocks: [],
  providers: [],
  activityTypes: [],
  showOnlyActive: true,
});

/**
 * Рахує кількість активних фільтрів (кожна категорія — один фільтр, діапазон дат — один)
 */
export const countActiveFilters = (filters: ActivityFilters): number => {
  return [
    filters.products.length > 0,
    filters.clients.length > 0,
    filters.stocks.length > 0,
    filters.providers.length > 0,
    filters.activityTypes.length > 0,
    !!filters.serialNumber,
    !!filters.fromDate || !!filters.toDate,
    filters.showOnlyActive === false,
  ].filter(Boolean).length;
};

/**
 * Перевіряє, чи є активні фільтри
 */
export const hasActiveFilters = (filters: ActivityFilters): boolean => countActiveFilters(filters) > 0;
